import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as state from '../../../../../../../../state'
import * as modals from '../../../modals'

/** Component for displaying the Space records assigned to a cluster. */
@ngCore.Component({
  imports: [
    ds.table.Component,
    ds.overlay.confirmation.Component,
    modals.assignRecordsToCluster.Component,
  ],
  selector: 'atn-space-cluster-assigned-records',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.space.full.clusterAssignedRecords.Collection} */
  public readonly assignedRecordsEc = ngCore.inject(
    state.space.full.clusterAssignedRecords.Collection,
  )

  /** Canonical table input for records assigned to the cluster. */
  public readonly tableConfig = {
    collection: this.assignedRecordsEc,
    view: {
      creation: () => this.addRecordsClickHandler(),
      showColumnSettings: false,
      title: 'Assigned Space Records',
    },
  } satisfies ds.table.ec.Config.Input<state.space.full.clusterAssignedRecords.TypeParams>

  /** Opens the add-records modal */
  public addRecordsClickHandler = () => {
    this.assignedRecordsEc.plugins.editingPlugin.feature.actions.edit
      .from('ClusterAssignedRecords.AddRecords.Clicked')
      .dispatch({
        id: ec.plugins.standard.editing.models.CreationId.generate(),
      })
  }

  /** Handles confirmation of removing a record from the cluster. */
  public confirmDeletionClickHandler(): void {
    this.assignedRecordsEc.plugins.editingPlugin.feature.actions.submit
      .from(
        'ClusterAssignedRecords.Delete.Confirmation.Footer.Buttons.Confirm.Clicked',
      )
      .dispatch({ delete: true })
  }

  /** Handles cancellation of removing a record from the cluster. */
  public cancelDeletionClickHandler(): void {
    this.assignedRecordsEc.plugins.editingPlugin.feature.actions.discard
      .from(
        'ClusterAssignedRecords.Delete.Confirmation.Footer.Buttons.Cancel.Clicked',
      )
      .dispatch({ delete: true })
  }
}
